import { ACCESSORY_RECEIVE, ACCESSORY_LOAD_ERROR, ACCESSORY_MODAL_HIDE } from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    accessories: [],
    visible: false,
    errors: {},
};

export const accessory = (
    state = defaultState,
    action
) => {
    switch (action.type) {
        case ACCESSORY_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
            case ACCESSORY_MODAL_HIDE:
                return {
                    ...state,
                    ...action.payload,
                };
            case ACCESSORY_LOAD_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};